import React from "react";
import { Icon, Stack } from "@bookingcom/bui-react";
import { useFlightDetailsTimelineController } from "./useFlightDetailsTimeline.controller.js";
import { FlightDetailsSectionTitleDesktopUI, FlightDetailsSegmentAccordionDesktopUI } from "../../../../ui/FlightDetails/index.js";
import { TimelineSegment } from "../../../Timeline/components/TimelineSegment.js";
import { track } from "@flights/et-universal";
import { flights_funnel_new_fd_page_desktop } from "../../../../../utils/experiments/funnel/flights_funnel_new_fd_page_desktop.js";
import { useI18n, t } from "@bookingcom/lingojs-react";
import { TravelInsuranceIcon } from "@bookingcom/bui-assets-react/streamline";
function isSegmentDirect(flight, segmentIndex) {
    return flight?.segments?.[segmentIndex]?.legs?.length === 1;
}
export function FlightDetailsTimelineNewDesktop(props) {
    const { flight } = props;
    const i18n = useI18n();
    const { segments } = useFlightDetailsTimelineController({ flight });
    return (React.createElement(Stack, { gap: 2 },
        React.createElement(FlightDetailsSectionTitleDesktopUI, { title: i18n.trans(t("flights_fd_heading_flight")), asset: track("flights_funnel_new_fd_page_desktop") === 1
                ? { assetName: "FlightsYourFlights", setName: "illustrations-traveller" }
                : undefined }),
        segments.map((segment, idx) => (React.createElement(FlightDetailsSegmentAccordionDesktopUI, { key: segment.title, title: segment.titleInline, subtitle: React.createElement(Stack, { gap: 1 },
                segment.subtitle,
                segment.isVirtualInterlining ? (React.createElement(Stack, { direction: "row", gap: 1 },
                    React.createElement(Icon, { svg: TravelInsuranceIcon, size: "small" }),
                    React.createElement(Stack.Item, { grow: true }, i18n.trans(t("flights_selftransfer_guarantee_protected"))))) : undefined), airlineCodes: segment.airlineCodes, attributes: { "data-testid": `timeline_segment_${idx}` }, titleAttributes: { "data-testid": "timeline_segment_title" }, subtitleAttributes: {
                "aria-label": segment.subtitleAria,
                "data-testid": "timeline_segment_flight_duration"
            }, onOpen: () => {
                isSegmentDirect(flight, idx)
                    ? flights_funnel_new_fd_page_desktop.goals.expandDirect()
                    : flights_funnel_new_fd_page_desktop.goals.expandNonDirect();
            } },
            React.createElement(TimelineSegment, { noMargin: true, hideHeading: true, segmentIndex: idx, segment: segment.data }))))));
}
